import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
// import { RestLink } from 'apollo-link-rest'; // TODO
import { BatchHttpLink } from '@apollo/client/link/batch-http';
import { setContext } from '@apollo/client/link/context';
import { ApolloLink } from '@apollo/client/link/core';
import { onError as onApolloLinkError } from '@apollo/client/link/error';
import { RetryLink } from '@apollo/client/link/retry';
import { ISession } from '../types';
import urls from '../urls';
import { getOperationSource, J1GraphQLOperationSource } from '../util/apollo';
// import _merge from 'lodash/merge';
import createOnApolloLinkErrorHandler from '../util/createOnApolloLinkErrorHandler';
import handleSnapState from '../util/handleSnapState';

const win = window as any;

export default class ClientWithSnap extends ApolloClient<any> {
  session: ISession;

  constructor({
    clientState = {} as { resolvers?: any },
    cacheConfig = {} as any,
    session = {} as ISession,
    onError = (_err: any) => {
      /**/
    },
  } = {}) {
    const cache = new InMemoryCache(cacheConfig);
    let soloQueryCount = 0;

    if (win.__PRELOADED_STATE__) {
      cache.restore(win.__PRELOADED_STATE__);
    }
    // _merge(clientState, { cache });

    const errorLink = onApolloLinkError(
      createOnApolloLinkErrorHandler(onError)
    );

    const httpLink = new BatchHttpLink({
      uri: urls.graphqlApi,
      fetch,
      batchKey: ({ operationName }: any) =>
        operationName && operationName.startsWith('solo_')
          ? `solo-${++soloQueryCount}`
          : 'batch',
    });

    const httpLinkComplianceV2 = new HttpLink({
      uri: urls.graphqlApiComplianceV2,
      fetch,
    });

    // const restLink = new RestLink({
    //   endpoints: {
    //     query: '/api/query',
    //   },
    // });

    const authLink = setContext((_, prevContext) => {
      if (this.session && this.session.account) {
        return {
          ...prevContext,
          client: this,
          account: this.session.account,
          headers: {
            Authorization: `Bearer ${this.session.accessToken}`,
            'Lifeomic-Account': this.session.account.id,
          },
        };
      }
    });

    const retryLink = new RetryLink();

    super({
      cache,
      resolvers: clientState.resolvers,
      link: ApolloLink.from([
        errorLink,
        retryLink,
        authLink,
        // stateLink,
        // restLink,
        ApolloLink.split(
          (operation) =>
            getOperationSource(operation) ===
            J1GraphQLOperationSource.ComplianceV2,
          httpLinkComplianceV2,
          httpLink
        ),
      ]),
    });

    handleSnapState(cache.extract.bind(cache));

    this.session = session;
  }
}
